import React, { createContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../api';

export const PeopleContext = createContext();

// People ("Requested by") are loaded from /api/people. Only active people are exposed
// to dropdowns; historical entries keep the name as text, so deactivation is safe.
// `username` is the logged-in user, used for admin-only writes (same trust model as login-info).
export const PeopleProvider = ({ children, username }) => {
  const [people, setPeople] = useState([]);

  const fetchPeople = useCallback(async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/people`, { params: { active: 1 } });
      setPeople(Array.isArray(res.data) ? res.data : []);
    } catch {
      /* keep current list */
    }
  }, []);

  useEffect(() => { fetchPeople(); }, [fetchPeople]);

  const addPerson = async (name, department) => {
    if (!name || !department) return;
    await axios.post(`${API_BASE_URL}/api/people`, { username, name, department });
    await fetchPeople();
  };

  const updatePerson = async (index, updated) => {
    const person = people[index];
    if (!person) return;
    await axios.put(`${API_BASE_URL}/api/people/${person.id}`, { username, ...updated });
    await fetchPeople();
  };

  return (
    <PeopleContext.Provider value={{ people, addPerson, updatePerson, fetchPeople }}>
      {children}
    </PeopleContext.Provider>
  );
};
